import { ReactNode } from 'react';
import { InfoButton } from '@/web/components/InfoButton/InfoButton';
import { Heading } from '@coverflex-tech/hypernova';
import { css } from './BenefitPageHeader.css';

interface IProps {
  title?: ReactNode;
  advantages?: ReactNode[];
  rightHeader?: ReactNode;
  onInfoClick?: () => void;
  learnMoreI18nKey?: string;
  learnMoreI18nLinkKey?: string;
  topTitle?: ReactNode;
}

export const BenefitPageHeader = ({
  topTitle,
  title,
  advantages = [],
  rightHeader,
  onInfoClick,
  learnMoreI18nKey,
  learnMoreI18nLinkKey,
}: IProps) => {
  return (
    <div>
      <div className={css.heading}>
        <div>
          {topTitle && (
            <Heading level={1} levelSize={4}>
              {topTitle}
            </Heading>
          )}
          {title && <Heading level={1}>{title}</Heading>}
        </div>
        <div className={css.rightHeader}>
          {rightHeader}
          {learnMoreI18nLinkKey && (
            <InfoButton learnMoreLinkKey={learnMoreI18nLinkKey} />
          )}
          {onInfoClick && (
            <InfoButton
              onClick={onInfoClick}
              learnMoreI18nKey={learnMoreI18nKey}
            />
          )}
        </div>
      </div>
      <div className={css.advantages[topTitle ? 'regular' : 'small']}>
        {advantages.map((advantage, idx) => (
          <div key={`advantage-${idx}`} className={css.advantage}>
            <span className={css.advantageSpan}>{advantage}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
